import axios from "axios";
import { useEffect, useState } from "react";
import { Pause, Play, Repeat, Trash2, Zap } from "lucide-react";
import { money } from "../lib/format";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function RecurringManager({ refreshKey, onChanged }) {
  const [rules, setRules] = useState([]);
  const [notice, setNotice] = useState("");

  useEffect(() => {
    axios.get(`${API}/recurring`).then(r => setRules(r.data)).catch(() => setRules([]));
  }, [refreshKey]);

  const call = async (fn, ok) => {
    try { await fn(); setNotice(ok); onChanged?.(); }
    catch (e) { setNotice(e?.response?.data?.detail || "İşlem başarısız"); }
  };

  const toggle = r => call(() => axios.patch(`${API}/recurring/${r.id}`, { active: !r.active }), r.active ? "Tekrar duraklatıldı" : "Tekrar devam ediyor");
  const remove = r => call(() => axios.delete(`${API}/recurring/${r.id}`), "Tekrar kaldırıldı; geçmiş kayıtlar korundu");
  const runNow = async () => {
    try {
      const { data } = await axios.post(`${API}/recurring/run`);
      setNotice(data.created ? `${data.created} gider otomatik eklendi` : "Eklenecek yeni ay yok");
      onChanged?.();
    } catch (e) { setNotice(e?.response?.data?.detail || "İşlem başarısız"); }
  };

  const due = rules.filter(r => r.is_due).length;

  return (
    <section className="panel recurring-panel" data-testid="recurring-panel">
      <div className="panel-head">
        <div>
          <p className="eyebrow">TEKRARLAYAN GİDERLER</p>
          <h3>Her ay otomatik eklenenler</h3>
        </div>
        <div className="actions">
          <span className="unit" data-testid="recurring-count">{rules.filter(r => r.active).length} aktif</span>
          <button className="outline-btn" data-testid="recurring-run-button" onClick={runNow} title="Bekleyen ayları şimdi ekle">
            <Zap size={15}/> {due ? `Şimdi ekle (${due})` : "Kontrol et"}
          </button>
        </div>
      </div>
      {notice && <div className="notice" data-testid="recurring-notice">{notice}</div>}
      <ul className="recurring-list" data-testid="recurring-list">
        {rules.map(r => (
          <li key={r.id} className={`recurring-item ${r.active ? "" : "paused"}`} data-testid={`recurring-item-${r.id}`}>
            <span className="log-icon"><Repeat size={14}/></span>
            <div className="recurring-body">
              <b>{r.description}</b>
              <small>{r.group} · her ayın {r.day_of_month}. günü · {r.start_month}'den beri{r.active && r.next_date ? ` · sonraki: ${r.next_date}` : " · duraklatıldı"}</small>
            </div>
            <strong className="amount expense">{money(r.amount, r.currency)}</strong>
            <div className="row-actions">
              <button className="icon-btn" data-testid={`recurring-toggle-${r.id}`} title={r.active ? "Duraklat" : "Devam et"} onClick={() => toggle(r)}>
                {r.active ? <Pause size={15}/> : <Play size={15}/>}
              </button>
              <button className="icon-btn danger" data-testid={`recurring-delete-${r.id}`} title="Tekrarı kaldır" onClick={() => remove(r)}><Trash2 size={15}/></button>
            </div>
          </li>
        ))}
        {!rules.length && <li className="empty-log">Henüz tekrarlayan gider yok. Gider eklerken "Her ay tekrar ediyor" kutusunu işaretleyin.</li>}
      </ul>
    </section>
  );
}
